module.exports = __webpack_public_path__ + "static/media/CTLA_4-216w.e348273f.webp";